import React from 'react';
import { useNavigate } from "react-router-dom";

import { Button, Form, Modal } from 'react-bootstrap';
import {IoIosArrowForward} from 'react-icons/io';

import '../EmailVerification.scss';

const CodeErrorModal = (props: any) => {

  const navigate = useNavigate();
  const goHome = (): void => {
    window.location.replace('https://motorsportgames.com/')
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      className='code-modal-container-lmu'
    >
      <img src="/lmu-logo-full.png" height="240" className="verify-logo-lmu" />
      <Modal.Header className="code-modal-header-lmu msg-header-text-lmu">
        <Modal.Title id="contained-modal-title-vcenter" className="msg-header-text-lmu code-modal-title">
          Account Verification Error
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="code-modal-body-lmu msg-text-lmu">
        <div className="container msg-text-lmu">
          <div className="row msg-text-lmu">
            The server encountered an error while verifying your e-mail address. Please try again later.
          </div>
          <br></br>
          <div className="row msg-text">
            {props?.info?.message ?? "Unknown error"}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="code-modal-footer-lmu msg-text">
        <Button className="code-modal-submit-button msg-text"
          onClick={goHome}>
          <span>OK
            <IoIosArrowForward className="code-modal-submit-icon" size="0.75rem"/>
          </span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CodeErrorModal;
